/**
 * On #checkout click: reads cart-total-price / items-count from .subtotal-final.
 * If total is 0 and item count > 0, clears the cart.
 */
(function () {
  'use strict';

  var routes = window.theme && window.theme.routes && window.theme.routes.cart
    ? window.theme.routes.cart
    : {};
  var clearPath = (routes.clear || '/cart/clear') + '.js';

  function getSubtotalEl(checkoutBtn) {
    var cartRoot = checkoutBtn.closest('cart-drawer, cart-page, cart-content');
    if (cartRoot) {
      var scoped = cartRoot.querySelector('.subtotal-final');
      if (scoped) {
        return scoped;
      }
    }

    return document.querySelector('.subtotal-final');
  }

  function readCartTotalsFromDom(checkoutBtn) {
    var subtotalEl = getSubtotalEl(checkoutBtn);
    if (!subtotalEl) {
      return null;
    }

    var totalPrice = parseInt(subtotalEl.getAttribute('cart-total-price'), 10);
    var itemCount = parseInt(subtotalEl.getAttribute('items-count'), 10);

    if (Number.isNaN(totalPrice) || Number.isNaN(itemCount)) {
      return null;
    }

    return {
      totalPrice: totalPrice,
      itemCount: itemCount,
    };
  }

  function shouldClearCart(totals) {
    return totals.totalPrice === 0 && totals.itemCount > 0;
  }

  function clearCart() {
    return fetch(clearPath, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(function (response) {
      return response.json();
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var checkoutBtn = event.target.closest('#checkout');
      if (!checkoutBtn) {
        return;
      }

      var totals = readCartTotalsFromDom(checkoutBtn);
      if (!totals || !shouldClearCart(totals)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      clearCart()
        .then(function (cart) {
          document.dispatchEvent(
            new CustomEvent('cart:changed', {
              detail: { cartData: cart, cart: cart },
              bubbles: true,
            }),
          );
        })
        .catch(function () {
          var form = checkoutBtn.closest('form');
          if (form) {
            form.submit();
          }
        });
    },
    true,
  );
})();
